import Axios from "axios";
import Authorization from './auth';
import { executeCall } from "./utils";

const crudder = (domain, resource, withAuth = true) => {
    const url = `${domain}/${resource}`;

    const getHeaders = () => withAuth ? Authorization() : {};

    return {
        get options() {
            return { headers: getHeaders(), url };
        },
        list: () => executeCall(() => Axios.get(url, { headers: getHeaders() })),
        history: () => executeCall(() => Axios.get(url + `/history`, { headers: getHeaders() })),
        unreadCount: () => executeCall(() => Axios.get(url + `/unread-count`, { headers: getHeaders() })),
        markRead: (id, source) => executeCall(() => Axios.patch(url + `/${id}/read`, { source }, { headers: getHeaders() })),
        markAllRead: () => executeCall(() => Axios.patch(url + `/read-all`, {}, { headers: getHeaders() })),
        deleteNotification: (id, source) => executeCall(() => Axios.delete(url + `/${id}`, { headers: getHeaders(), data: { source } })),
        register: (data) => executeCall(() => Axios.post(url + `/register`, data, { headers: getHeaders() })),
        unregister: (data) => executeCall(() => Axios.post(url + `/unregister`, data )),
        sendTestPush: () => executeCall(() => Axios.post(url + `/web-push-test`, {}, { headers: getHeaders() })),
    };
};


export default crudder;